module.exports = __webpack_public_path__ + "static/img/MAG2.fa6beed7.jpg";